import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { NavLink } from "react-router-dom";
// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
} from "@material-ui/core";
import { makeStyles, createMuiTheme, MuiThemeProvider} from "@material-ui/core/styles";

// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';

//cookies
import {get_cookies} from "../../../components/Cookies/Cookies";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
}));



const JcPortalSalesOrderHQ = () => {
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [sono, setSono] = useState('');
	const [modalOpen, setModalOpen] = useState(false);
	const [downloadFlag, setDownloadFlag] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: addDays(new Date(), 7),
	});
	const classes = useStyles();

	const [useridNo, setuseridNo] = useState(get_cookies('branchidno'));

	// Data Fetching
	useEffect(() => {
		data();
	}, []);

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);

	const dataFilter = async () => {
		setDataLoaded(false);
        await axios.get(
			process.env.REACT_APP_API_URL+'jc_portal_so_table', {
            params:{
                date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
                date_to: format(dateRange.endDate, "yyyy-MM-dd"),   //format(dateRange.endDate, "yyyy/MM/dd/")
                jc_user_id_no: useridNo,  
				portalshop_so_no: sono
            }
        }).then((res)=>{
			setPosts(res.data.data);
		}).catch((error)=>{
			// console.log(error.message);
		})
		setDataLoaded(true);
    }

	const data = async () => {
		setDataLoaded(true);
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};
	const columns = [
		{
			name: "date_created",
			label: "Date Created",
		},
		{
			name: "idno",
			label: "ID No",
		},
		{
			name: "portalshop_so_no",
			label: "JC Portal So No",
		},
		{
			name: "shipping",
			label: "Status",
			options: {
				customBodyRenderLite: (dataIndex) => {
					let isdelivered =  posts[dataIndex].isdelivered;
					let shipping =  posts[dataIndex].shipping;
					if(isdelivered == 0){
							if(shipping === -1){
								return(
									<div>For Pickup</div>
								)
							}
							else{
								return(
									<div>On Process</div>
								)
							}
					}else if(isdelivered===1){
						return(
							<div>Delivered</div>
						)
					}else if(isdelivered===2){
						return(
							<div>In Preparation</div>
						)
					}else if(isdelivered===3){
						return(
							<div>In Transit</div>
						)
					}
				},
			},
		},
		{
			name: "action",
			label: "Action",
			options: {
				download: false, //exclude this column in csv export
				customBodyRenderLite: (dataIndex) => {
					let release_status =  posts[dataIndex].release_status;
					let isdelivered =  posts[dataIndex].isdelivered;
					let waybill_no =  posts[dataIndex].waybill_no;
					let sono = 'xd';
					let idno = posts[dataIndex].idno;
					let portalshop_so_no = posts[dataIndex].portalshop_so_no;
					if(release_status === 0){
						return(
							<Grid container spacing={1}>
								<Grid item xs={12} sm={6} md={12} lg={3} xl={6}>
									<NavLink to={"/sales/jcportalsales-view/"+idno+"/"+portalshop_so_no+"/view"}>
										<Button variant="contained" color="primary">
											View
										</Button>	
									</NavLink> 
								</Grid>
								<Grid item xs={12} sm={6} md={12} lg={4} xl={6}>
									<NavLink to={"/sales/jcportalsales-view/"+idno+"/"+portalshop_so_no+"/release"}>
										<Button variant="contained" color="primary"> 
											Release
										</Button>	
									</NavLink> 	
								</Grid>
							</Grid>
							)
					}else{
						if(waybill_no === ""){
							return(
								<Grid container spacing={1}>
									<Grid item xs={12} sm={6} md={12} lg={3} xl={6}>
										<NavLink to={"/sales/jcportalsales-view/"+idno+"/"+portalshop_so_no+"/view"}>
											<Button variant="contained" color="primary">
												View
											</Button>	
										</NavLink> 
									</Grid>
									<Grid item xs={12} sm={6} md={12} lg={6} xl={6}>
									<NavLink to={"/sales/jcportalsales-view/"+idno+"/"+portalshop_so_no+"/waybill"}>
											<Button variant="contained" color="primary"> 
												Enter Waybill
											</Button>	
										</NavLink> 	
									</Grid>
								</Grid>
								)
		 				}else{
		 			if(isdelivered === 1){
						return(
							<Grid container spacing={1}>
								<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
									<NavLink to={"/sales/jcportalsales-view/"+idno+"/"+portalshop_so_no+"/view"}>
										<Button variant="contained" color="primary">
											Print
										</Button>	
									</NavLink> 
								</Grid>
							</Grid>
							)
		 			}else{
						return(
							<Grid container spacing={1}>
								<Grid item xs={12} sm={6} md={12} lg={3} xl={6}>
									<NavLink to={"/sales/jcportalsales-view/"+idno+"/"+portalshop_so_no+"/view"}>
										<Button variant="contained" color="primary">
											View
										</Button>	
									</NavLink> 
								</Grid>
								<Grid item xs={12} sm={6} md={12} lg={6} xl={6}>
									<NavLink to={"/sales/jcportalsales-view/"+idno+"/"+portalshop_so_no+"/delivery"}>
										<Button variant="contained" color="primary"> 
											Confirm Delivery
										</Button>	
									</NavLink> 	
								</Grid>
							</Grid>
							)
		 			}
		// 		}
					}
				}
				},
			},
	 	}
	];

	const options = {
		filter: false,
		// filterType: "dropdown",
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		download: false,  //add this
		print: false,
		viewColumns: false, //add this
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		downloadOptions: {
			filename : 'JcPortalSalesOrder.csv' //change filename of csv
		}
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<ShoppingCartIcon />
				</div>
				<NavLink to={"/sales"}><h2 style={{color:"black"}}>Sales</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<h2>Jc Portal Sales Order HQ</h2>
			</div>
			<div className="page-container">
				<div style={style}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={4} lg={3} xl={3}>
                                <TextField
                                    id="outlined-basic"
                                    label="Select Date"
                                    variant="outlined"
                                    onFocus={() => setOpen(true)}
                                    fullWidth={true}
                                    autoComplete="off"
                                    value={`${format(
                                        dateRange.startDate,
                                        "MM/dd/yyyy"
                                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                />
                                <DateRangePicker
                                    open={open}
                                    toggle={toggle}
                                    onChange={(range) => dateRangeHandler(range)}
                                /> 
                            </Grid>
							<Grid item xs={8} md={5} lg={3} xl={3}>
									<TextField
													id="outlined-required"
													label="JC Portal SO Number"
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={sono} //to avoid label overlapping bug
													onChange={(e)=>{setSono(e.target.value)}}
													InputProps={{
														type: 'text',
													  }}
										/>
							</Grid>
                            <Grid item xs={1} lg={1} xl={1}>
                                <Button variant="contained" style ={{marginTop: "20px"}} color="primary"  onClick={() => {dataFilter()}}>Search</Button>
                            </Grid>
                        </Grid>        
                    </div>

				{!dataLoaded ? (
					<Preloader />
				) : (
					// <MuiThemeProvider theme={getMuiTheme()}>
						<MUIDataTable
							title={
								<div>
									<div className="table-subtitle">Table</div>
									<div className="table-title">
									Jc Portal Sales Order HQ
									</div>
								</div>
							}
							data={posts}
							columns={columns}
							options={options}
						/>
				//   </MuiThemeProvider>
				)}
			</div>
		</div>
	);
};

export default JcPortalSalesOrderHQ;